import { useApi } from 'services';

export const useSendStamp = (idOperation) => useApi(
    `/v2/operation/${idOperation}/stamp`,
    'POST',
    {},
    {},
);

export const useReSendStamp = (idOperation) => useApi(
    `/v2/operation/${idOperation}/stamp/re-send`,
    'POST',
    {},
    {},
);

export const useDeleteVoidStamp = (idOperation) => useApi(
    `/v2/operation/${idOperation}/stamp`,
    'DELETE',
    {},
    {},
);